export async function performSearch(query, collection, page = 1, emptyTest = false) {
    if (emptyTest) {
        return [];
    }

    const search = new URLSearchParams();
    search.set('q', query);
    search.set('page', page);
    if (collection && collection !== 'all') {
        search.set('collection', collection);
    }

    try {
        if (query) {
            return fetch('/api/search?' + search.toString())
                .then(res => res.json())
                .then(data => data.docs.map(processSearchResult));
        }

        return [];
    } catch (error) {
        try {
            // eslint-disable-next-line compat/compat
            const devResponse = await fetch('/api/search.json?' + search.toString());
            const result = await devResponse.json();

            return result.docs
        } catch (error) {
            console.error('Failed to load search:', error);
            throw error;
        }
    }
}

/**
 *
 * @param {*} result
 */
function processSearchResult(result) {
    //
    switch (result.collectionType) {
        case 'posts':
            result.authors = false;
            if (result.data?.authors) {
                result.authors = result.data.authors
                    .map(author => author.title)
                    .join(', ');
            }
            break;
    }
    return result;
}
